import '@babel/polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import './plugins/vuetify'
import './plugins/notifications'
import './plugins/services'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import './filters'
import Notifications from './components/Notifications.vue'
import PasswordInput from './components/PasswordInput.vue'
import config from '@/config'

Vue.prototype.config = config

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.component('notifications', Notifications)
Vue.component('password-input', PasswordInput)

sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
